import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row mx-auto my-3" }
const _hoisted_2 = { class: "col-sm-12 col-md-6" }
const _hoisted_3 = { class: "col-sm-12 col-md-6" }
const _hoisted_4 = { class: "row mx-auto my-3" }
const _hoisted_5 = { class: "col-sm-12 col-md-6" }
const _hoisted_6 = { class: "col-sm-12 col-md-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_scheduled_training_sessions = _resolveComponent("scheduled-training-sessions")!
  const _component_scheduled_interviews = _resolveComponent("scheduled-interviews")!
  const _component_pending_interviews = _resolveComponent("pending-interviews")!
  const _component_schedule_training_session = _resolveComponent("schedule-training-session")!
  const _component_financial_report = _resolveComponent("financial-report")!
  const _component_tab = _resolveComponent("tab")!
  const _component_completed_training_sessions = _resolveComponent("completed-training-sessions")!
  const _component_completed_interviews = _resolveComponent("completed-interviews")!
  const _component_canceled_training_sessions = _resolveComponent("canceled-training-sessions")!
  const _component_tabs = _resolveComponent("tabs")!

  return (_openBlock(), _createBlock(_component_tabs, {
    options: { useUrlFragment: false },
    "nav-class": "nav nav-pills m-3",
    "nav-item-class": "nav-item col-md-6 col-sm-12 text-center",
    "nav-item-link-class": "nav-link btn-dashboard-sub-nav",
    "nav-item-link-active-class": "active"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_tab, {
        prefix: "<h4>",
        suffix: " / <i class='far fa-calendar-alt text-primary'></i></h4>",
        name: "Scheduled"
      }, {
        default: _withCtx(() => [
          _cache[0] || (_cache[0] = _createElementVNode("hr", { class: "w-75 mx-auto" }, null, -1)),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_scheduled_training_sessions, {
                scheduled_training_sessions: _ctx.scheduled_training_sessions,
                scheduled_training_sessions_total: _ctx.scheduled_training_sessions_total,
                loading: _ctx.scheduled_training_sessions_loading,
                is_trainer: true,
                onChangePage: _ctx.changePage
              }, null, 8, ["scheduled_training_sessions", "scheduled_training_sessions_total", "loading", "onChangePage"]),
              (_ctx.store.getters.dashboard_view == _ctx.UserRole.HEADTRAINER)
                ? (_openBlock(), _createBlock(_component_scheduled_interviews, {
                    key: 0,
                    scheduled_interviews: _ctx.scheduled_interviews,
                    scheduled_interviews_total: _ctx.scheduled_interviews_total,
                    loading: _ctx.scheduled_interviews_loading,
                    onChangePage: _ctx.changePage
                  }, null, 8, ["scheduled_interviews", "scheduled_interviews_total", "loading", "onChangePage"]))
                : _createCommentVNode("", true),
              (_ctx.store.getters.dashboard_view == _ctx.UserRole.HEADTRAINER)
                ? (_openBlock(), _createBlock(_component_pending_interviews, {
                    key: 1,
                    pending_interviews: _ctx.pending_interviews,
                    pending_interviews_total: _ctx.pending_interviews_total,
                    loading: _ctx.pending_interviews_loading,
                    onChangePage: _ctx.changePage
                  }, null, 8, ["pending_interviews", "pending_interviews_total", "loading", "onChangePage"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_schedule_training_session, {
                training_session_types: _ctx.training_session_types,
                training_session_users: _ctx.training_session_users,
                training_scenarios: _ctx.training_scenarios,
                schedule_loading: _ctx.schedule_loading,
                onRefresh: _ctx.refresh
              }, null, 8, ["training_session_types", "training_session_users", "training_scenarios", "schedule_loading", "onRefresh"]),
              _createVNode(_component_financial_report, { financial_data: _ctx.financial_data }, null, 8, ["financial_data"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_tab, {
        prefix: "<h4>",
        suffix: " / <i class='fas fa-check text-primary'></i></h4>",
        name: "Completed"
      }, {
        default: _withCtx(() => [
          _cache[1] || (_cache[1] = _createElementVNode("hr", { class: "w-75 mx-auto" }, null, -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_completed_training_sessions, {
                completed_training_sessions: _ctx.completed_training_sessions,
                completed_training_sessions_total: _ctx.completed_training_sessions_total,
                loading: _ctx.completed_training_sessions_loading,
                is_trainer: true,
                onChangePage: _ctx.changePage
              }, null, 8, ["completed_training_sessions", "completed_training_sessions_total", "loading", "onChangePage"]),
              (_ctx.store.getters.dashboard_view == _ctx.UserRole.HEADTRAINER)
                ? (_openBlock(), _createBlock(_component_completed_interviews, {
                    key: 0,
                    completed_interviews: _ctx.completed_interviews,
                    completed_interviews_total: _ctx.completed_interviews_total,
                    loading: _ctx.completed_interviews_loading,
                    onChangePage: _ctx.changePage
                  }, null, 8, ["completed_interviews", "completed_interviews_total", "loading", "onChangePage"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_schedule_training_session, {
                training_session_types: _ctx.training_session_types,
                training_session_users: _ctx.training_session_users,
                training_scenarios: _ctx.training_scenarios,
                schedule_loading: _ctx.schedule_loading,
                onRefresh: _ctx.refresh
              }, null, 8, ["training_session_types", "training_session_users", "training_scenarios", "schedule_loading", "onRefresh"]),
              _createVNode(_component_financial_report, { financial_data: _ctx.financial_data }, null, 8, ["financial_data"]),
              _createVNode(_component_canceled_training_sessions, {
                canceled_training_sessions: _ctx.canceled_training_sessions,
                canceled_training_sessions_total: _ctx.canceled_training_sessions_total,
                loading: _ctx.canceled_training_sessions_loading,
                is_trainer: true,
                onChangePage: _ctx.changePage
              }, null, 8, ["canceled_training_sessions", "canceled_training_sessions_total", "loading", "onChangePage"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}